import React, {Component} from 'react';
class PageHeader extends Component{
    render(){
        return(
            <div class="grid">
                
            <div class="header-container">
                <div >
                <h5> left</h5>
            </div>
            <div >
                <h5>right</h5>
            </div>
            </div>
            
            </div>
        )
    }
}

export default PageHeader